// Aspek taxonomy → "section" untuk tampilan.
//
// FULLY DATA-DRIVEN: 1 aspek aktif = 1 section. Urutan & label diambil langsung
// dari `m_taxonomy_aspect` (urutan & nama). Menambah/menggabung/menghapus aspek
// cukup lewat menu "Tambah Aspek" di Master — TANPA ubah kode di sini. Endpoint
// /aspects sudah memfilter is_active & mengurutkan by `urutan`.
//
// Satu-satunya kode yang di-special-case: DOKUMEN_TERKAIT — section ini render
// daftar dokumen otomatis (DokumenTerkaitView), bukan editor konten.

export const DOKUMEN_TERKAIT_KODE = "DOKUMEN_TERKAIT";

/** Bentuk minimal aspek yang dibutuhkan untuk pengelompokan. */
export interface AspectLike {
  id: string;
  kode: string;
  nama: string;
  urutan: number;
  is_active: boolean;
  /** NULL = section (top-level). Terisi = sub-aspek (tidak jadi section). */
  parent_id: string | null;
}

export interface AspectSection<A extends AspectLike> {
  id: string;
  label: string;
  aspects: A[];
  /** Section dokumen ditampilkan via DokumenTerkaitView, bukan editor/konten. */
  isDokumen: boolean;
}

/**
 * Section = aspek TOP-LEVEL (parent_id NULL), terurut by `urutan`. Sub-aspek
 * (parent_id terisi) BUKAN section — itu hanya unit ekstraksi. Dinamis penuh:
 * section baru muncul otomatis saat aspek top-level ditambah di Master.
 */
export function buildSections<A extends AspectLike>(
  sortedAspects: A[],
): AspectSection<A>[] {
  return sortedAspects
    .filter((a) => a.parent_id == null)
    .map((a) => ({
      id: a.kode,
      label: a.nama,
      aspects: [a],
      isDokumen: a.kode === DOKUMEN_TERKAIT_KODE,
    }));
}
